import axiosInstance from ".";

export const fetchGiveaways = () =>{
  return axiosInstance.get(`/v1/giveaways/active`);
}

export const fetchGiveaway = (id) =>
  axiosInstance.get(`/v1/giveaways/${id}`);

  export const fetchUserGiveaways = () =>
  axiosInstance.get (`v1/giveaways/by-user`)    

